/** Entry point: picks the scene from the URL (spec 06 §8: every scene reachable without clicking). */

import { startDropdev } from './dropdev';
import { startGame } from './game';
import { startItemsLineup } from './itemsLineup';
import { startLineup } from './lineup';
import { startLookdev } from './lookdev';
import { startMenuScene } from './menuScene';
import { startTitleScene } from './titleScene';

const canvas = document.querySelector<HTMLCanvasElement>('canvas#game');
if (!canvas) throw new Error('no canvas#game');
const params = new URLSearchParams(window.location.search);
const scenes: Record<string, (c: HTMLCanvasElement, p: URLSearchParams) => void> = {
  game: startGame,
  lookdev: startLookdev,
  drop: startDropdev,
  lineup: startLineup,
  items: startItemsLineup,
  title: startTitleScene,
  menu: startMenuScene,
};
(scenes[params.get('scene') ?? 'game'] ?? startGame)(canvas, params);
